import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="fhir-resource-picker"
export default class extends Controller {
  static targets = [
    "fhirResourceId",
    "submitButton"
  ]

  connect() {  
  }

  chooseFhirResourceId(e) {
    e.target.classList.toggle("border-light-gray")
    e.target.classList.toggle("border-purple")

    if (this.activeFhirResource) {
      this.activeFhirResource.classList.toggle("border-light-gray")
      this.activeFhirResource.classList.toggle("border-purple")
    }

    this.fhirResourceIdTarget.value = e.target.dataset.fhirResourceId
    this.activeFhirResource = e.target

    // because hidden fields don't trigger change events, we need to trigger one ourselves, so form validation works
    var event = new Event("change");
    this.fhirResourceIdTarget.dispatchEvent(event);

    this.submitButtonTarget.disabled = false
  }

}
